module.exports = __webpack_public_path__ + "static/img/earthCode2.aab46496.png";